import { createInjectionState, useLocalStorage } from '@vueuse/core'
import { computed, ref, shallowRef } from 'vue'
import axios from 'axios'
import Store from 'store'
import truncate from 'lodash/truncate'
import StorageKeys from '../../../../common/storage-keys'
import constants from '@/generated/constants.js'

const [useProvideTextToSpeech, _useTextToSpeech] = createInjectionState(({
  defaultTitle = '',
  defaultInput = '',
  maxInputLength = 5000
}) => {
  let titleValue = defaultTitle
  let inputValue = defaultInput

  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.get('ai-assistant') === '1' || searchParams.get('avatar-video') === '1') {
    titleValue = searchParams.get('title') ?? truncate(inputValue, { length: 80 })
    inputValue = searchParams.get('input') ?? truncate(Store.get(StorageKeys.AI_ASSISTANT.RESPONSE), { length: maxInputLength })
  }

  const title = ref(titleValue)
  const input = ref(inputValue)
  const voice = useLocalStorage(
    StorageKeys.VOICE_RECORDER.VOICE,
    constants.App_Extensions_OpenAi_Enums_Voice.ALLOY
  )

  const formData = computed(() => ({
    input: input.value,
    voice: voice.value
  }))

  const { errors, isLoading, synthesize: synthesizeBase } = useSynthesize()

  const synthesize = () => synthesizeBase(formData.value)

  return {
    title,
    input,
    maxInputLength,
    voice,

    synthesize,
    isLoading,
    errors
  }
})

function useTextToSpeech () {
  const res = _useTextToSpeech()
  if (!res) {
    throw new Error('useTextToSpeech is called without provider.')
  }
  return res
}

function useSynthesize () {
  const errors = shallowRef({})
  const isLoading = ref(false)

  const synthesize = async (formData) => {
    try {
      isLoading.value = true

      const res = await axios.post(Spark.router('api.text-to-speech.synthesize'), formData)
      return res.data.audio_content
    } catch (err) {
      if (err.response?.status === 422) {
        errors.value = err.response.data
      }

      await Promise.reject(err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading,
    synthesize,
    errors
  }
}

export {
  useProvideTextToSpeech,
  useTextToSpeech,
  useSynthesize
}
